import { format, parseISO } from "date-fns"

const moneyFormatter = new Intl.NumberFormat("ru-RU", {
    style: "currency",
    currency: "RUB",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
})

export const formatLoyaltyMoney = (value: string | null | undefined): string => {
    if (value === null || typeof value === "undefined" || value === "") return "н/д"
    const normalized = Number(value)

    return Number.isFinite(normalized) ? moneyFormatter.format(normalized) : `${value} ₽`
}

export const formatLoyaltyNumber = (value: number | string): string => {
    const normalized = Number(value)
    return Number.isFinite(normalized) ? new Intl.NumberFormat("ru-RU").format(normalized) : String(value)
}

export const formatLoyaltyDateTime = (value: string | null): string => {
    if (!value) return "н/д"
    const parsed = parseISO(value)

    return Number.isNaN(parsed.getTime()) ? value : format(parsed, "dd.MM.yyyy HH:mm")
}

export const formatExtendedFieldsSince = (value: string | null | undefined): string => {
    if (!value) return "н/д"
    const parsed = parseISO(value)

    return Number.isNaN(parsed.getTime()) ? value : format(parsed, "dd.MM.yyyy")
}
